module.exports = __webpack_public_path__ + "static/media/instant_switch_logo.74201cdf.png";